import { useEffect } from "react";

export const DEFAULT_PAGE_TITLE = "ChordMaster";

/**
 * Formats song page title as "${artist} - ${title} | ChordMaster".
 * Gracefully handles missing artist or title.
 */
export function formatSongTitle(artist?: string | null, title?: string | null): string {
  const cleanArtist = artist?.trim();
  const cleanTitle = title?.trim();

  if (cleanArtist && cleanTitle) {
    return `${cleanArtist} - ${cleanTitle} | ${DEFAULT_PAGE_TITLE}`;
  }
  if (cleanTitle) {
    return `${cleanTitle} | ${DEFAULT_PAGE_TITLE}`;
  }
  if (cleanArtist) {
    return `${cleanArtist} | ${DEFAULT_PAGE_TITLE}`;
  }
  return DEFAULT_PAGE_TITLE;
}

/**
 * Custom React hook to set document.title and revert to defaultTitle when unmounted or changed.
 */
export function useDocumentTitle(title?: string | null, defaultTitle: string = DEFAULT_PAGE_TITLE): void {
  useEffect(() => {
    const nextTitle = title?.trim() || defaultTitle;
    document.title = nextTitle;

    return () => {
      document.title = defaultTitle;
    };
  }, [title, defaultTitle]);
}
